import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setUser } from '../store/authSlice'
import authService from '../services/authService'
import { useTranslation } from '../hooks/use-i18n'

const AuthCallback: React.FC = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const token = searchParams.get('token')
    if (!token) {
      setError(t('error.missingToken'))
      return
    }
    const finishLogin = async () => {
      try {
        authService.setAuthData({ _id: '', name: '', email: '' } as any, token)
        const user = await authService.getCurrentUser()
        authService.setAuthData(user, token)
        dispatch(setUser(user))
        navigate('/dashboard', { replace: true })
      } catch (err: any) {
        setError(err.response?.data?.message || t('error.signInFailed'))
      }
    }
    finishLogin()
  }, [searchParams, navigate, dispatch, t])

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-8 pb-12 px-4">
        <div className="blue-sky-card rounded-3xl p-8 max-w-md w-full text-center">
          <h2 className="text-2xl font-bold text-white mb-4">{t('auth.callback.failedTitle')}</h2>
          <p className="text-white/80 mb-6">{error}</p>
          <a href="/login" className="text-sky-400 hover:text-sky-300 underline">
            {t('auth.callback.backToSignIn')}
          </a>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center pt-8 pb-12 px-4">
      <div className="blue-sky-card rounded-3xl p-8 max-w-md w-full text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sky-400 mx-auto mb-4" />
        <p className="text-white/90">{t('auth.callback.completing')}</p>
      </div>
    </div>
  )
}

export default AuthCallback
